import './login.scss';
import { Auth } from '@shared/Auth';
import { applyHighContrastSetting } from '@shared/theme-manager';

// no user here, reuse what the last logged in user of this browser had
applyHighContrastSetting();

let isSubmitting = false;

// Kuura's sync to IAM runs asynchronously after a successful Kuura login, so give it a moment before retrying
const IAM_RETRY_DELAY_MS = 2000;

if (document.querySelector('#logintabletBtn')) {
    // main login
    $('#command').on('submit', e => {
        e.stopPropagation();
        e.preventDefault();

        if (isSubmitting) return;

        isSubmitting = true;

        login(e.currentTarget as HTMLFormElement)
            .catch(onLoginError)
            .finally(() => {
                isSubmitting = false;
            });
    });
} else {
    // mobile login
    const cleanBtn = document.querySelector('#cleanLoginBtn');
    if (cleanBtn) {
        cleanBtn.addEventListener('click', e => {
            e.preventDefault();
            const formEl = document.querySelector('form');
            const action = formEl.getAttribute('action');
            formEl.setAttribute('action', action + (action.includes('?') ? '&' : '?') + 'no-state');
            formEl.submit();
        });
    }
}

// The office pages cannot work without an IAM token, so a Kuura session is only kept when IAM login succeeds too.
async function login(form: HTMLFormElement): Promise<void> {
    const username = String($('#usernameInput').val());
    const password = String($('#passwordInput').val());

    setLoginButtonDisabled(true);
    Auth.clearToken();

    if (await Auth.fetchToken(username, password)) {
        submitForm(form);
        return;
    }

    // IAM login failed. Log in to Kuura anyway: it validates the credentials and syncs the user to IAM.
    const kuuraResponse = await postForm(form);
    const kuuraLoginFailed = isLoginPage(kuuraResponse.url);

    if (kuuraLoginFailed) {
        showErrors(await readLoginErrors(kuuraResponse));
        setLoginButtonDisabled(false);
        return;
    }

    await delay(IAM_RETRY_DELAY_MS);

    if (await Auth.fetchToken(username, password)) {
        window.location.assign(kuuraResponse.url);
        return;
    }

    await logout(form);
    showErrors([kuura.getMessage('login.iamLoginFailed')]);
    setLoginButtonDisabled(false);
}

// Only the Kuura requests can throw (network error). A Kuura session may exist at this point, so drop it.
async function onLoginError(error: unknown): Promise<void> {
    console.error('Login failed', error);
    await logout(document.getElementById('command') as HTMLFormElement);
    showErrors([kuura.getMessage('login.iamLoginFailed')]);
    setLoginButtonDisabled(false);
}

function submitForm(form: HTMLFormElement): void {
    $(form).off('submit');
    form.submit();
}

function postForm(form: HTMLFormElement): Promise<Response> {
    const body = new URLSearchParams(new FormData(form) as any);

    return fetch(form.action, { method: 'POST', body, credentials: 'same-origin' });
}

function logout(form: HTMLFormElement): Promise<Response> {
    const logoutUrl = new URL('logout.htm', form.action).toString();

    return fetch(logoutUrl, { method: 'POST', credentials: 'same-origin' }).catch(() => null);
}

// Kuura redirects a failed login back to the login page, and a successful one anywhere else
function isLoginPage(url: string): boolean {
    const pathname = new URL(url).pathname;

    return pathname === window.location.pathname || pathname.endsWith('/login.htm');
}

// The login page Kuura redirected to already renders the reason (wrong password, MFA required...) and clears it
// from the session, so take the messages from that response instead of loading the page again.
async function readLoginErrors(response: Response): Promise<string[]> {
    const html = await response.text();
    const page = new DOMParser().parseFromString(html, 'text/html');
    const errors = Array.from(page.querySelectorAll('#command #wrong')).map(el => el.textContent.trim());

    return errors.length > 0 ? errors : [kuura.getMessage('login.wrongpwd')];
}

function showErrors(messages: string[]): void {
    const form = $('#command');
    form.find('#wrong').remove();

    const errorElements = messages.map(message => $('<p id="wrong">').text(message));
    form.prepend(errorElements);
}

function setLoginButtonDisabled(disabled: boolean): void {
    (document.querySelector('#loginBtn') as HTMLButtonElement).disabled = disabled;
}

function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}
